import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';
import BillsPaymentTableRecords from '../BillsPaymentTableRecord';

const PendingBillsPayment = () => (
  <div className="bills-payment-root-cover"><BillsPaymentTableRecords hasNameAndImage defaultUrl={AdminRouteName.pendingBillsPaymentRoute} tabStatus="pending" toggleStorageId="pending-bills-payment-table-col" recordPermission="can-get-bills-payment" /></div>
);
export default PendingBillsPayment;
